export default __webpack_public_path__ + "static/life-ff8d34a7c75363e59f68f60dc539c510.svg";